import { XSOLN_PREFIX } from '../../../constants/dataSource.constants';
import { paramDsName } from '../constants/parameterNames';
import { typeDataConnection } from '../constants/parameterTypes';
import { failure } from '../helpers/commandResult';
import { getParamValue } from '../helpers/parameter.accessors';
import { getDataConnection } from '../helpers/qRules.dataConnection.helpers';

const optionalParameters = [];
const requiredParameters = {
    [paramDsName]: {
        description: 'Name of the data connection.',
        type: typeDataConnection,
    },
};

const description = 'Returns the current URL of the specified data connection.';

function executeAsync({ dataConnections, parameters }) {
    const dsName = getParamValue(parameters, paramDsName);
    const dataConnection = getDataConnection(dataConnections, dsName);

    if (!dataConnection || !dataConnection.getUrl) {
        return failure(
            'GetConnectionUrl is not supported for this connection type',
        );
    }

    try {
        const connUrl = dataConnection.getUrl();
        const searchIndex = connUrl.search(new RegExp(XSOLN_PREFIX, 'i'));

        if (searchIndex >= 0) {
            return connUrl.substr(XSOLN_PREFIX.length);
        }

        return connUrl;
    } catch (e) {
        return failure(
            'GetConnectionUrl is not supported for this connection type',
        );
    }
}

const GetConnectionUrl = {
    description,
    executeAsync,
    optionalParameters,
    requiredParameters,
};

export default GetConnectionUrl;
